<template>
	<div class="container mt-4">
		<div class="cards-grid">
			<router-link to="/leaves/new" class="dashboard-card new-leave-card">
				<div class="card-icon">
					<i class="far fa-file-import"></i>
				</div>
				<div class="card-content">
					<h3>Nouvelle demande</h3>
					<p>Créer une demande de congé</p>
				</div>
			</router-link>
			<div></div>
		</div>
		<div class="dashboard-section mt-4">
			<div class="section-header d-flex justify-content-between align-items-center">
				<h2><i class="fas fa-calendar-alt"></i> Mes demandes de congés</h2>
				<n-radio-group v-model:value="selectedView" name="leaveView">
					<n-radio-button value="pending">En attente</n-radio-button>
					<n-radio-button value="processed">Traitées</n-radio-button>
				</n-radio-group>
			</div>
			<div v-if="selectedView === 'pending'">
				<Leaves v-if="pendingLeaves.length > 0" :leaves="pendingLeaves"></Leaves>
				<div v-else class="no-leaves">
					<p>Aucune demande en attente</p>
				</div>
			</div>
			<div v-else>
				<Leaves v-if="processedLeaves.length > 0" :leaves="processedLeaves"></Leaves>
				<div v-else class="no-leaves">
					<p>Aucune demande traitée</p>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.new-leave-card .card-icon {
	background: #fff3e0;
	color: #f57c00;
}

.comments-section h4,
.attachments-section h4 {
	font-size: 1rem;
	color: #2c3e50;
	margin-bottom: 0.5rem;
}

.attachment-link {
	color: #3498db;
	text-decoration: none;
	transition: color 0.2s;
}

.attachment-link:hover {
	color: #2980b9;
}

.actions {
	margin-top: 1rem;
}

.no-leaves {
	text-align: center;
	padding: 2rem;
	color: #6c757d;
	font-style: italic;
}

@media (max-width: 768px) {
	.dashboard-section {
		padding: 1rem;
	}

	.cards-grid {
		gap: 1rem;
	}
}
</style>

<script setup>
import {computed, onMounted, ref} from 'vue'
import {useStore} from 'vuex'
import Leaves from '../Leaves.vue'

const store = useStore();

const showedLeavesDetails = ref([]);
const selectedView = ref('pending');

const leaves = computed(() => store.getters.getLeaves)
const pendingLeaves = computed(() => leaves.value.filter(leave => leave.status === 'pending'))
const processedLeaves = computed(() => leaves.value.filter(leave => leave.status !== 'pending'))

const handleConfirmeCancelLeave = (leave) => {
	store.dispatch('cancelLeave', leave.id)
}

onMounted(() => {
	store.dispatch('fetchLeaves')
});
</script>